
function isDigit(ch) {
	if ((ch >= '0') && (ch <= '9'))
		return true;
	else
		return false;
}

function isAlpha(ch) {
	if (((ch >= 'a') && (ch <= 'z')) || ((ch >= 'A') && (ch <= 'Z')))
		return true;
	else
		return false;
}

function isAlnum(ch) {
	if (isAlpha(ch) || isDigit(ch))
		return true;
	else
		return false;
}

function notIn(str1, str2) {
	var i = 0;
	var j = str2.length;
	for (; i < j; i++) {
		var str3 = str2.charAt(i);
		if (str1.indexOf(str3) != -1)
			return false;
	}
	return true;
}

function checkUsername(username, mustBeQuoted) {
	var i = 0;
	var j = username.length;
	if (username.charAt(0) != '"') {
		if ((username.charAt(0) < ' ') || (username.charAt(0) > '~')
			|| !notIn(mustBeQuoted, username.charAt(0)))
			return false;
		for (i = 1; i < j; i++) {
			if (((username.charAt(i) < ' ') || (username.charAt(i) > '~')
				|| !notIn(mustBeQuoted, username.charAt(i)))
				&& (username.charAt(i - 1) != '\\'))
				return false;
		}
	}
	else {
		if (username.charAt(j - 1) != '"')
			return false;
		for (i = 1; i < j - 1; i++) {
			if (((username.charAt(i) == '\n') || (username.charAt(i) == '\r')
				|| (username.charAt(i) == '\"'))
				&& (username.charAt(i - 1) != '\\'))
				return false;
		}

	}
	return true;
}

function checkNr(nr) {
	var i = 0;
	var j = nr.length;

	if (j < 1)
		return false;

	for (; i < j; i++)
		if ((nr.charAt(i) < '0') || (nr.charAt(i) > '9'))
			return false;

	return true;
}

function checkIpnr(ipnr) {
	var iL = 0;
	var iC = 0;
	var i = 0;
	var sNr = "";

	for (; i < ipnr.length; i++) {
		if (ipnr.charAt(i) == '.') {
			if (!iL || (iL > 3) || parseInt(sNr, 10) > 255)
				return false;
			iC++;
			iL = 0;
			sNr = "";
			continue;
		}
		if (isDigit(ipnr.charAt(i))) {
			iL++;
			sNr = sNr + ipnr.charAt(i);
			continue;
		}
		return false;
	}

	if (parseInt(sNr, 10) > 255)
		return false;
	if (((iC == 3) && (iL >= 1) && (iL <= 3)) || ((iC == 4) && (!iL)))
		return true;
	else
		return false;
}

function checkFqdn(fqdn) {
	var iL = 0;
	var iC = 0;
	var i = fqdn.length - 1;

	if ((fqdn.charAt(0) == '.') || (fqdn.charAt(0) == '-'))
		return false;
	if (fqdn.charAt(i) == '.')
		i = i - 1;

	for (; i >= 0; i--) {
		if (fqdn.charAt(i) == '.') {
			if (iL < 2 && iC < 2)
				return false;
			if (fqdn.charAt(i - 1) == '-')
				return false;
			iC++;
			iL = 0;
			continue;
		}
		if (isAlnum(fqdn.charAt(i))) {
			iL++;
			continue;
		}
		if (fqdn.charAt(i) == '-') {
			if (!iL)
				return false;
			iL++;
			continue;
		}
		return false;
	}

	if (!iC || (iL == 1 && iC < 2) || (!iL && iC == 1)) {
		return false;
	}

	return true;

}

function checkHostname(hostname) {
	if (hostname.charAt(0) == '[') {
		if (hostname.charAt(hostname.length - 1) != ']')
			return false;
		var ipnr = hostname.substring(1, hostname.length - 1);
		return checkIpnr(ipnr);
	}

	if (hostname.charAt(0) == '#') {
		var nr = hostname.substring(1, hostname.length);
		return checkNr(nr);
	}

	return checkFqdn(hostname);
}

function checkEmailAdr(address) {
	var status = true;
	var username = "";
	var hostname = "";

	if (address.length < 8)
		return false;

	var seperate = address.lastIndexOf("@");
	if (seperate == -1)
		return false;

	username = address.substring(0, seperate);
	if (!checkUsername(username, "<>()[],;:@\" "))
		return false;

	hostname = address.substring(seperate + 1, address.length);
	if (!checkHostname(hostname))
		return false;

	return true;
}

function checkEmail(email, allowFullname) {
	var existFullname = false;
	var status = true;
	var fullname = "";
	var adress = "";
	if (email.length < 8)
		return false;
	var emailBegin = email.indexOf("<");
	var emailEnd = email.lastIndexOf(">");

	if ((emailBegin == -1) && (emailEnd == -1))
		return checkEmailAdr(email);

	if (((emailBegin == -1) && (emailEnd != -1))
		|| ((emailBegin != -1) && (emailEnd == -1)))
		return false;

	adress = email.substring(emailBegin + 1, emailEnd);

	if (!checkEmailAdr(adress))
		return false;

	if (email.length == adress.length + 2)
		return true;
	else
		if (!allowFullname)
			return false;

	if (emailEnd == email.length - 1) {
		if (emailBegin == 0)
			return true;
		if (email.charAt(emailBegin - 1) != ' ')
			return false;
		fullname = email.substring(0, emailBegin - 1);
		return checkUsername(fullname, "<>()[],;:@\"");
	}

	return false;

}

/* global dermaselScreenReaderText */
(function ($) {

	/*

	// Variables and DOM Caching.
	var $body = $( 'body' ),
		$customHeader = $body.find( '.custom-header' ),
		$branding = $customHeader.find( '.site-branding' ),
		$navigation = $body.find( '.navigation-top' ),
		$navWrap = $navigation.find( '.wrap' ),
		$navMenuItem = $navigation.find( '.menu-item' ),
		$menuToggle = $navigation.find( '.menu-toggle' ),
		$menuScrollDown = $body.find( '.menu-scroll-down' ),
		$sidebar = $body.find( '#secondary' ),
		$entryContent = $body.find( '.entry-content' ),
		$formatQuote = $body.find( '.format-quote blockquote' ),
		isFrontPage = $body.hasClass( 'dermasel-front-page' ) || $body.hasClass( 'home blog' ),
		navigationFixedClass = 'site-navigation-fixed',
		navigationHeight,
		navigationOuterHeight,
		navPadding,
		navMenuItemHeight,
		idealNavHeight,
		navIsNotTooTall,
		headerOffset,
		menuTop = 0,
		resizeTimer;

	// Ensure the sticky navigation doesn't cover current focused links.
	$( 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex], [contenteditable]', '.site-content-contain' ).filter( ':visible' ).focus( function() {
		if ( $navigation.hasClass( 'site-navigation-fixed' ) ) {
			var windowScrollTop = $( window ).scrollTop(),
				fixedNavHeight = $navigation.height(),
				itemScrollTop = $( this ).offset().top,
				offsetDiff = itemScrollTop - windowScrollTop;

			// Account for Admin bar.
			if ( $( '#wpadminbar' ).length ) {
				offsetDiff -= $( '#wpadminbar' ).height();
			}

			if ( offsetDiff < fixedNavHeight ) {
				$( window ).scrollTo( itemScrollTop - ( fixedNavHeight + 50 ), 0 );
			}
		}
	});

	// Set properties of navigation.
	function setNavProps() {
		navigationHeight      = $navigation.height();
		navigationOuterHeight = $navigation.outerHeight();
		navPadding            = parseFloat( $navWrap.css( 'padding-top' ) ) * 2;
		navMenuItemHeight     = $navMenuItem.outerHeight() * 2;
		idealNavHeight        = navPadding + navMenuItemHeight;
		navIsNotTooTall       = navigationHeight <= idealNavHeight;
	}

	// Make navigation 'stick'.
	function adjustScrollClass() {

		// Make sure we're not on a mobile screen.
		if ( 'none' === $menuToggle.css( 'display' ) ) {

			// Make sure the nav isn't taller than two rows.
			if ( navIsNotTooTall ) {

				// When there's a custom header image or video, the header offset includes the height of the navigation.
				if ( isFrontPage && ( $body.hasClass( 'has-header-image' ) || $body.hasClass( 'has-header-video' ) ) ) {
					headerOffset = $customHeader.innerHeight() - navigationOuterHeight;
				} else {
					headerOffset = $customHeader.innerHeight();
				}

				// If the scroll is more than the custom header, set the fixed class.
				if ( $( window ).scrollTop() >= headerOffset ) {
					$navigation.addClass( navigationFixedClass );
				} else {
					$navigation.removeClass( navigationFixedClass );
				}

			} else {

				// Remove 'fixed' class if nav is taller than two rows.
				$navigation.removeClass( navigationFixedClass );
			}
		}
	}

	// Set margins of branding in header.
	function adjustHeaderHeight() {
		if ( 'none' === $menuToggle.css( 'display' ) ) {

			// The margin should be applied to different elements on front-page or home vs interior pages.
			if ( isFrontPage ) {
				$branding.css( 'margin-bottom', navigationOuterHeight );
			} else {
				$customHeader.css( 'margin-bottom', navigationOuterHeight );
			}

		} else {
			$customHeader.css( 'margin-bottom', '0' );
			$branding.css( 'margin-bottom', '0' );
		}
	}

	// Set icon for quotes.
	function setQuotesIcon() {
		$( dermaselScreenReaderText.quote ).prependTo( $formatQuote );
	}

	// Add 'below-entry-meta' class to elements.
	function belowEntryMetaClass( param ) {
		var sidebarPos, sidebarPosBottom;

		if ( ! $body.hasClass( 'has-sidebar' ) || (
			$body.hasClass( 'search' ) ||
			$body.hasClass( 'single-attachment' ) ||
			$body.hasClass( 'error404' ) ||
			$body.hasClass( 'dermasel-front-page' )
		) ) {
			return;
		}

		sidebarPos       = $sidebar.offset();
		sidebarPosBottom = sidebarPos.top + ( $sidebar.height() + 28 );

		$entryContent.find( param ).each( function() {
			var $element = $( this ),
				elementPos = $element.offset(),
				elementPosTop = elementPos.top;

			// Add 'below-entry-meta' to elements below the entry meta.
			if ( elementPosTop > sidebarPosBottom ) {
				$element.addClass( 'below-entry-meta' );
			} else {
				$element.removeClass( 'below-entry-meta' );
			}
		});
	}

	// Fire on document ready.
	$( document ).ready( function() {

		// If navigation menu is present on page, setNavProps and adjustScrollClass.
		if ( $navigation.length ) {
			setNavProps();
			adjustScrollClass();
		}

		// If 'Scroll Down' arrow in present on page, calculate scroll offset and bind an event handler to the click event.
		if ( $menuScrollDown.length ) {

			if ( $( 'body' ).hasClass( 'admin-bar' ) ) {
				menuTop -= 32;
			}
			if ( $( 'body' ).hasClass( 'blog' ) ) {
				menuTop -= 30; // The div for latest posts has no space above content, add some to account for this.
			}
			if ( ! $navigation.length ) {
				navigationOuterHeight = 0;
			}

			$menuScrollDown.click( function( e ) {
				e.preventDefault();
				$( window ).scrollTo( '#primary', {
					duration: 600,
					offset: { top: menuTop - navigationOuterHeight }
				});
			});
		}

		adjustHeaderHeight();
		setQuotesIcon();
		if ( true === supportsInlineSVG() ) {
			document.documentElement.className = document.documentElement.className.replace( /(\s*)no-svg(\s*)/, '$1svg$2' );
		}

		if ( true === supportsFixedBackground() ) {
			document.documentElement.className += ' background-fixed';
		}
	});

	// If navigation menu is present on page, adjust it on scroll and screen resize.
	if ( $navigation.length ) {

		// On scroll, we want to stick/unstick the navigation.
		$( window ).on( 'scroll', function() {
			adjustScrollClass();
			adjustHeaderHeight();
		});

		// Also want to make sure the navigation is where it should be on resize.
		$( window ).resize( function() {
			setNavProps();
			setTimeout( adjustScrollClass, 500 );
		});
	}

	$( window ).resize( function() {
		clearTimeout( resizeTimer );
		resizeTimer = setTimeout( function() {
			belowEntryMetaClass( 'blockquote.alignleft, blockquote.alignright' );
		}, 300 );
		setTimeout( adjustHeaderHeight, 1000 );
	});

	// Add header video class after the video is loaded.
	$( document ).on( 'wp-custom-header-video-loaded', function() {
		$body.addClass( 'has-header-video' );
	});

	*/

})(jQuery);

!function (n, r) { "function" == typeof define && define.amd ? define(r) : "object" == typeof exports ? module.exports = r() : n.transformicons = r() }(this || window, function () { "use strict"; var n = {}, r = "tcon-transform", t = { transform: ["click"], revert: ["click"] }, e = function (n) { return "string" == typeof n ? Array.prototype.slice.call(document.querySelectorAll(n)) : "undefined" == typeof n || n instanceof Array ? n : [n] }, o = function (n) { return "string" == typeof n ? n.toLowerCase().split(" ") : n }, f = function (n, r, f) { var c = (f ? "remove" : "add") + "EventListener", u = e(n), s = u.length, a = {}; for (var l in t) a[l] = r && r[l] ? o(r[l]) : t[l]; for (; s--;)for (var d in a) for (var v = a[d].length; v--;)u[s][c](a[d][v], i) }, i = function (r) { n.toggle(r.currentTarget) }; return n.add = function (r, t) { return f(r, t), n }, n.remove = function (r, t) { return f(r, t, !0), n }, n.transform = function (t) { return e(t).forEach(function (n) { n.classList.add(r) }), n }, n.revert = function (t) { return e(t).forEach(function (n) { n.classList.remove(r) }), n }, n.toggle = function (t) { return e(t).forEach(function (t) { n[t.classList.contains(r) ? "revert" : "transform"](t) }), n }, n });
transformicons.add('.tcon');

function getImageLightness(imageSrc, callback) {
	var img = document.createElement("img");
	img.src = imageSrc;
	img.style.display = "none";
	document.body.appendChild(img);

	var colorSum = 0;

	img.onload = function () {
		// create canvas
		var canvas = document.createElement("canvas");
		canvas.width = this.width;
		canvas.height = this.height;

		var ctx = canvas.getContext("2d");
		ctx.drawImage(this, 0, 0);

		var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
		var data = imageData.data;
		var r, g, b, avg;

		for (var x = 0, len = data.length; x < len; x += 4) {
			r = data[x];
			g = data[x + 1];
			b = data[x + 2];

			avg = Math.floor((r + g + b) / 3);
			colorSum += avg;
		}

		var brightness = Math.floor(colorSum / (this.width * this.height));
		callback(brightness);
	}
}

function checkImg() {

}

// Extra function to control menu state from anywhere on your page/ inside your script
function expandoffcanvasmenu(action) { //param: 'open', 'close', or empty to toggle menu state
	var togglebox = document.getElementById("togglebox")
	var newstate = (action == 'open') ? true : (action == 'close') ? false : !togglebox.checked
	togglebox.checked = newstate
}

(function ($) {

	$(function () {
		$('a[href*="#"]:not([href="#"])').click(function () {
			if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if (target.length) {
					$('html, body').animate({
						scrollTop: target.offset().top - 50
					}, 1000);
					return false;
				}
			}
		});
	});

	function checkHeader() {

		if ($('.inhalte-outer').length > 0) {

			window.setTimeout(function () {
				$('.A').addClass('active');
				$('#A').addClass('active');
			}, 1000);

			$('.inhalte-navi').find('a').each(function () {

				var oneLetter = $(this);

				oneLetter.click(function (event) {

					event.preventDefault();

					$('.inhalte-navi a').removeClass('active');
					$('.inhalte-navi li').removeClass('active');

					$('.inhalte-outer').removeClass('active');

					$('#' + oneLetter.attr('class')).addClass('active');

					oneLetter.addClass('active');
					oneLetter.parent().addClass('active');

				});

			});

		}

		if ($('.absoluterhead').length > 0) {

			var winda = $(window).width();

			if (winda > 650) {

				$('.absoluterhead').css('left', ((($(window).width() - $('.absoluterhead').width()) / 2)) - 40);

			} else if (winda >= 400) {

				$('.absoluterhead').css('left', ((($(window).width() - $('.absoluterhead').width()) / 2)) - 40);

			} else {

				$('.absoluterhead').css('left', ((($(window).width() - $('.absoluterhead').width()) / 2)) - 20);

			}

			$('.content_header_desktop').each(function (i, val) {

				checkImg();

				var datHead = $(this);
				datHead.css('opacity', '0');

				var headerOuterHeight = $('.bild_header_hoehe').height();
				var datHeadHeight = datHead.height();

				var topper = (headerOuterHeight - datHeadHeight) / 2;

				if (headerOuterHeight < 150) {

					datHead.find('p').css('display', 'none');
					//datHead.find('h1').css('margin-bottom','0');
					topper = ((headerOuterHeight - datHeadHeight) / 2) + 15;
				} else {
					datHead.find('p').css('display', 'block');
					//datHead.find('h1').css('margin-bottom','20px');
					topper = (headerOuterHeight - datHeadHeight) / 2;
				}

				datHead.css('top', topper);

				window.setTimeout(function () {
					datHead.css('opacity', '1');
				}, 200);

			});

		} else {

			$('.content_header_desktop').each(function (i, val) {

				checkImg();

				var datHead = $(this);
				datHead.css('opacity', '0');

				var headerOuterHeight = $('.header_desktop').height();
				var datHeadHeight = datHead.height();

				var topper = (headerOuterHeight - datHeadHeight) / 2;

				datHead.css('top', topper);

				window.setTimeout(function () {
					datHead.css('opacity', '1');
				}, 200);

			});

		}

		var winda = $(window).width();

		if (winda > 650) {

			$('.outerh').each(function (i, val) {

				var datHead = $(this);
				datHead.css('opacity', '0');

				var headerOuterHeight = $('.joy').height();
				var datHeadHeight = datHead.height();

				var topper = (headerOuterHeight - datHeadHeight) / 2;

				datHead.css('top', topper);

				window.setTimeout(function () {
					datHead.css('opacity', '1');
				}, 200);

			});

			$('.text').each(function (i, val) {

				/*
					var datHead = $(this);
					datHead.css('opacity','0');

					window.setTimeout(function(){

					var headerOuterHeight = $('.start-item').height();
					var datHeadHeight = datHead.height();

					var topper = (headerOuterHeight - datHeadHeight) / 2;

					datHead.css('top', topper);

						datHead.css('opacity','1');
					   },200);
				*/

			});

		} else {

			$('.outerh').each(function (i, val) {

				var datHead = $(this);

				datHead.css('top', '0');

			});

			$('.text').each(function (i, val) {

				var datHead = $(this);

				//datHead.css('top', '0');

			});

		}

	}

	function positionSliderButts() {

		window.setTimeout(function () {

			/*

			$('.imager').matchHeight({
				byRow: true,
				property: 'height',
				target: null,
				remove: false
			});

			$('.produkt-grid-item').matchHeight({
				byRow: true,
				property: 'height',
				target: null,
				remove: false
			});

			$('.untertitel').matchHeight({
				byRow: true,
				property: 'height',
				target: null,
				remove: false
			});
			$('.panel-grid-cell').matchHeight({
				byRow: true,
				property: 'height',
				target: null,
				remove: false
			});

		*/

			$('.boxxer').matchHeight({
				byRow: false,
				property: 'height',
				target: null,
				remove: false
			});

			$('.boxxertitel').matchHeight({
				byRow: false,
				property: 'height',
				target: null,
				remove: false
			});

			$('.innervargas').matchHeight({
				byRow: true,
				property: 'height',
				target: null,
				remove: false
			});

			$('.teaser-content').matchHeight({
				byRow: false,
				property: 'height',
				target: null,
				remove: false
			});

			$('.box-inhalt').matchHeight({
				byRow: true,
				property: 'height',
				target: null,
				remove: false
			});

			$('.inhalt.timeline').matchHeight({
				byRow: false,
				property: 'height',
				target: null,
				remove: false
			});

			var heightr = $('.desktopper').height();
			$('.previousstart').css('top', ($('.desktopper').height() / 2) - 80);
			$('.nextstart').css('top', ($('.desktopper').height() / 2) - 80);

			$('.at-share-btn span').css('background-size', ' 31px!important');

			//alert("now");

		}, 700);

	}

	function initMap() {

		// Specify features and elements to define styles.
		var styleArray = [
			{
				featureType: "all",
				stylers: [
					{ saturation: -80 }
				]
			}, {
				featureType: "road.arterial",
				elementType: "geometry",
				stylers: [
					{ hue: "#00ffee" },
					{ saturation: 50 }
				]
			}, {
				featureType: "poi.business",
				elementType: "labels",
				stylers: [
					{ visibility: "off" }
				]
			}
		];

		// Create a map object and specify the DOM element for display.
		var map = new google.maps.Map(document.getElementById('mpos'), {
			center: { lat: 50.970859, lng: 7.015478 },
			scrollwheel: false,
			// Apply the map style array to the map.
			styles: styleArray,
			zoom: 15
		});
		var image = '../wp-content/themes/perlweiss/images/pin.png';
		var marker = new google.maps.Marker({
			map: map,
			position: { lat: 50.970859, lng: 7.015478 },
			title: 'perlweiss',
			icon: image
		});
	}

	$(document).scroll(function () {

		var winHeight = $(window).height();
		var winWidth = $(window).width();

		var scroll_top_master = Math.max($("html").scrollTop(), $("body").scrollTop());

		if (scroll_top_master > 640) {
			$('.fullrow.sticky').addClass('shine');
		} else {
			$('.fullrow.sticky').removeClass('shine');
		}

		/*if (winWidth > 960 && $('.subnav-fixxer').length > 0) {

			if ($('.siegel .bild').length > 0) {

			   var scroll_top_siegel = $('.siegel').offset();

			   //console.log(scroll_top_siegel.top);
			   //console.log(scroll_top_master);

			   if (scroll_top_master >= 10) {

				 $('.siegel .bild img:not(.siegel-blank)').each(function(i,val) {

					var disBild = $(this);

					if (!disBild.hasClass('fadeInLeftBig')) {
						 window.setTimeout(function() {

						 // disBild.addClass('animated').addClass('fadeIn');

					  }, 500 * i);
					}

				});

			  }

		   }

		  var scroll_top = $('.subnav-fixxer').offset();

		  if (scroll_top.top <= scroll_top_master) {

			$('.fixed-subnavi').addClass('affix');
			$('#header').addClass('rover');

		  } else {
			$('.fixed-subnavi').removeClass('affix');
			$('#header').removeClass('rover');
		  }

		} else {
		  $('.fixed-subnavi').removeClass('affix');
		  $('#header').removeClass('rover');
		}
	  */

	});

	$(document).ready(function () {

		if ($('.page-template-homepage').length > 0) {

			$('.fullrow.banner-content:eq(0)').css('background-position', '35% 50%');
			$('.fullrow.banner-content:eq(1)').css('background-position', '62% 50%');

			// $('.fullrow.banner-content:eq(0)').append('<div class="curtain"></div>');
			// $('.fullrow.banner-content:eq(1)').append('<div class="curtain"></div>');

		}

		if ($('.headerback').length > 0) {

			//alert($('.headerback').css('background-image'));

			if ($('.headerback').css('background-image') != '' && $('.headerback').css('background-image') != 'none') {
				$('.headerback').append('<div class="curtain"></div>');
			}

		}

		if ($('.inhaltertium').length > 0) {

			$('.inhaltertium').find('.inhalte-outer').each(function (i, val) {

				var item = $(this);
				var itemlabel = item.attr('id');

				var newContent = '<li class=""><a class="' + itemlabel + '" href="#">' + itemlabel + '</a></li>';

				$('.inhalte-navi').append(newContent);

			});

		}

		$('.choose-local-website').find('.chooser').click(function () {

			$(this).parent().find('.country-inner').toggleClass('active');

		});

		$('.linien_content').find('a').mouseenter(function () {
			$(this).closest('.img-container').addClass('show');
		}).mouseleave(function () {
			$(this).closest('.img-container').removeClass('show');
		});

		$('.linien_content').each(function () {

			var butt = $(this);

			butt.mouseenter(function () {
				butt.find('.img-container').addClass('show');
			}).mouseleave(function () {
				butt.find('.img-container').removeClass('show');
			});

		});

		//$('.therapie-link').find('a').html('<img src="/wp-content/themes/dermasel/images/180227_DS_Kachel_DermaSelTherapie_Logo_gross.jpg" alt="therapie">');
		//$('.wellness-link').find('a').html('<img src="/wp-content/themes/dermasel/images/180227_DS_Kachel_DermaSelTherapie_Logo_gross.jpg" alt="therapie">');
		//$('.pro-link').find('a').html('<img src="/wp-content/themes/dermasel/images/180227_DS_Kachel_DermaSelTherapie_Logo_gross.jpg" alt="therapie">');

		var waypoints = $('.waypoint').waypoint({
			handler: function (direction) {

				/* var item = '#'+this.element.id;

				 console.log(direction);

				 $('.anker-links a').removeClass('active');

				 $('.anker-links ul').find('li').each(function(i,val) {

				   var link = $(this).find('a');
				   var linkref = link.attr('href');

				   if (linkref == item) {
					 if(direction == 'down') {
					   link = $('.anker-links a:eq('+(i+1)+')');
					   link.addClass('active');
					 } else {

					   link.addClass('active');
					 }

				   }

				 });

		   */

			}
		});

		/*

		  $('.anker-links').find('a').each(function() {

			var link = $(this);

			link.click(function() {

			  $('.anker-links a').removeClass('active');
			  link.addClass('active');

			});

		  });

		*/

		$('.reasons').each(function () {

			/*  var row = $(this);
			  var headerText = row.find('.header-text');
			  var image = row.find('img');

			  headerText.css('height', row.height());
			  headerText.css('width', row.width() - image.width());
			 // headerText.css('background-color', 'red');
		*/

		});

		/*
		$( '#cd-dropdown' ).dropdown( {
			gutter : 5
		} );*/

		/*
		  $('.teaser-outer').each(function(i,val) {

			  var img = $(this).find('img');
			  var content = $(this).find('.teaser-content');

			  var className = 'coloris'+i;
			  $(this).addClass(className);

			  img.imgcolr(function (img, color) {
				  // `img` refers to the current img element
				  console.log(img);
				  // `color` is the grabbed color, a string like "#ededed"
				  console.log(color);

				  content.css('background-color', color);
				  $('<style>.teaser-outer.'+className+':after{border-color: ' + color + ';}</style>').appendTo('body');

			  });

		  });

		  */

		checkHeader();

		/*
		var canSell = $('.apobuy').find('li').length;

		if (canSell > 0) {

			$('.button.buy').click(function () {

				$('body').addClass('stop');
				$('#block-bewertungen-overlay').addClass('show');
				$('.modal_apo').addClass('vis');
				$('.closer-mobile').addClass('show');

				$('header#header').addClass('hide');

				return false;

			});

			$('.button.buy').css('display', 'block');

		} else {

			$('.button.buy').remove();

		}
		*/

		$('.country-href').click(function () {

			$('.country-sel').toggleClass('show');

			return false;

		});

		$('.country-closer').click(function () {

			$('.country-sel').toggleClass('show');

			return false;

		});

		$('.search-butt').click(function () {
			$('.dermasel-search-outer').toggleClass('show');
			$('#search-header-icon').toggleClass('show');
			$('#close-search-header-icon').toggleClass('show');
			$('.search-field:eq(0)').focus();

			if ($(this).find('i').hasClass('fa-search')) {
				$(this).find('i').removeClass('fa-search');
				$(this).find('i').addClass('fa-times');
			} else {
				$(this).find('i').addClass('fa-search');
				$(this).find('i').removeClass('fa-times');
			}

			return false;
		});

		$('.open-reviews, .user-review-href').click(function () {

			$('body').addClass('stop');
			$('#block-bewertungen-overlay').addClass('show');
			$('.block-bewertungen').addClass('bewertungen');
			$('#pre-comm').html('Bewertungen für');
			$('.block-bewertungen.bewertungen').addClass('show');
			$('.closer-mobile').addClass('show');

			$('header#header').addClass('hide');

			return false;

		});

		$('.open-my-review').click(function () {

			$('body').addClass('stop');
			$('#block-bewertungen-overlay').addClass('show');
			$('.block-bewertungen').addClass('bewerten');
			$('#pre-comm').html('Meine Bewertung für');
			$('.block-bewertungen.bewerten').addClass('show');
			$('.closer-mobile').addClass('show');

			$('header#header').addClass('hide');

			return false;

		});

		$('.closer-mobile, .closer, #block-bewertungen-overlay').click(function () {
			$('body').removeClass('stop');
			$('#block-bewertungen-overlay').removeClass('show');
			$('.block-bewertungen.bewertungen').removeClass('show');
			$('.block-bewertungen.bewerten').removeClass('show');
			$('.block-bewertungen').removeClass('bewerten');
			$('.block-bewertungen').removeClass('bewertungen');
			$('.closer-mobile').removeClass('show');
			$('.modal_apo').removeClass('vis');

			$('header#header').removeClass('hide');

		});

		$('.wp-review-comment-form-author').clone().insertBefore('.wp-review-comment-form-email');
		$('.wp-review-comment-form-author:eq(1)').find('input').attr('id', 'surname').attr('name', 'surname').attr('placeholder', 'Nachname*');

		$('.user-review-title').html('');

		$('#email-notes').html('Ihre E-Mail-Adresse und Nachname werden nicht veröffentlicht.<br />');
		$('.review-comment-field-msg').html('Wählen Sie ihre Sterne');
		$('#wp-review-comment-title-field').attr('placeholder', 'Titel Ihrer Bewertung*');
		$('#author').attr('placeholder', 'Vorname*');
		$('#email').attr('placeholder', 'E-Mail-Adresse*');
		$('#url').attr('placeholder', 'Stadt*');
		$('#comment').attr('placeholder', 'Ihre Bewertung*');

		$('.wp-review-comment-form-title').insertBefore('.wp-review-comment-form-comment');
		$('.wp-review-comment-form-rating').insertBefore('.wp-review-comment-form-title');

		//$('<span itemprop="reviewRating" itemscope itemtype="http://schema.org/Rating"><meta itemprop="ratingValue" content="3" /><meta itemprop="bestRating" content="5" /></span>').appendTo('.review-wrapper');

		$('.user-review-area.comments-review-area').insertAfter('.pre-review');
		$('#review').remove();
		$('.user-review-area.comments-review-area .review-star').each(function () {
			$(this).insertBefore($(this).parent().find('.user-total-wrapper'));
		});

		var total = $('.review-total-box').find('.wp-review-user-rating-total').text();
		var totalReviewers = $('.review-total-box').find('.wp-review-user-rating-counter').text();

		// alert(total);
		// alert(totalReviewers);

		if (totalReviewers > 0) {

			var bewertungLabel = 'Bewertungen';

			if (totalReviewers == 1) {
				bewertungLabel = 'Bewertung';
			}

			$('.review-total-box').html('<a href="" class="datAnchor user-review-href">' + total + '&nbsp;|&nbsp;' + totalReviewers + ' ' + bewertungLabel + '</a>');
		} else {
			$('.user-review-area.comments-review-area').remove();
			$('.reviews-href').remove();
		}

		setTimeout(function () {

			$('.user-review-href').click(function () {

				$('body').addClass('stop');
				$('#block-bewertungen-overlay').addClass('show');
				$('.block-bewertungen').addClass('bewertungen');
				$('.block-bewertungen.bewertungen').addClass('show');
				$('.closer-mobile').addClass('show');

				return false;

			});

		}, 1000);

		$('#commentform').submit(function () {

			var errors = false;
			$('.errormess').css('display', 'none');
			$('#wp-review-comment-title-field').removeClass('error');
			$('#author').removeClass('error');
			$('#surname').removeClass('error');
			$('#email').removeClass('error');
			$('#url').removeClass('error');
			$('#comment').removeClass('error');
			$('.review-comment-field-msg').removeClass('errorrat');

			if ($('#wp-review-comment-title-field').val() == '') {
				errors = true;
				$('#wp-review-comment-title-field').addClass('error');
			}
			if ($('#author').val() == '') {
				errors = true;
				$('#author').addClass('error');
			}
			if ($('#surname').val() == '') {
				errors = true;
				$('#surname').addClass('error');
			}
			if ($('#url').val() == '') {
				errors = true;
				$('#url').addClass('error');
			}
			if (!checkEmail($('#email').val())) {
				errors = true;
				$('#email').addClass('error');
			}
			if ($('#comment').val() == '') {
				errors = true;
				$('#comment').addClass('error');
			}

			if ($('.wp-review-user-rating-val:eq(1)').val() == '0') {
				errors = true;
				$('.review-comment-field-msg').addClass('errorrat');
			}

			if (errors) {
				$('.errormess').css('display', 'block');
				return false;
			} else {

				//return false;

				$('.errormess').css('display', 'none');
				$('.successmess').css('display', 'block');
				$('#author').val($('#author').val() + '#' + $('#surname').val());

				setTimeout(function () {

					$(this).submit();

				}, 3000);

			}

		});

		$('.presse-header').each(function (i, val) {

			var disHeaderRow = $(this);
			var disFilesRow = disHeaderRow.next();

			disHeaderRow.click(function () {

				console.log(disFilesRow);
				console.log(disFilesRow.css('height'));

				if (disFilesRow.css('height') == '0px') {
					disHeaderRow.find('.opener').addClass('open');
					disFilesRow.css('height', disFilesRow.find('.file-holder-inner').height());
				} else {
					disFilesRow.css('height', '0');
					disHeaderRow.find('.opener').removeClass('open');
				}
				console.log(disFilesRow.height());

			});

		});

		$(document).on('click', function (e) {

			console.log($(e.target));

			if (!$(e.target).closest('.country-sel').length) {
				$('.country-sel').removeClass('show');

			}

		});

		if ($(window).width() <= 960) {
			$('.siegel .bild img:not(.siegel-blank)').each(function (i, val) {

				$(this).css('opacity', '1');

			});

		}

		if ($(window).width() > 650) {

			$('.block-bewertungen').css('height', $(window).height() - 100);

		} else {

			$('.block-bewertungen').css('height', $(window).height() - 60);

		}

		$('.skip-link.skip-nav').click(function () {

			var hamburger = $(this);

			if (hamburger.hasClass('skip-active')) {
				hamburger.removeClass('skip-active');
				$('#header-nav').removeClass('skip-active');

				hamburger.find('i').addClass('fa-bars');
				hamburger.find('i').removeClass('fa-times');
			} else {
				hamburger.addClass('skip-active');
				$('#header-nav').addClass('skip-active');
				hamburger.find('i').removeClass('fa-bars');
				hamburger.find('i').addClass('fa-times');
			}

		});

		var winWidth = $(window).width();

		if (winWidth >= 1000) {

			$('.nav-primary').find('.level0.menu-item-has-children').each(function () {
				var mainli = $(this);
				mainli.find('a.level0').unbind();
			});

			$('.nav-primary').find('.level1.menu-item-has-children').each(function () {
				var mainli = $(this);
				mainli.find('a.level1').unbind();
			});

			$('.nav-primary').find('.level0').each(function () {

				var mainlink = $(this);

				mainlink.mouseenter(function () {

					mainlink.addClass('menu-active');
					mainlink.find('a.level0').addClass('active');

				}).mouseleave(function () {

					mainlink.removeClass('menu-active');
					mainlink.find('a.level0').removeClass('active');

				});
			});

		} else {

			$('.nav-primary').find('.level0.menu-item-has-children').each(function () {
				var mainli = $(this);
				mainli.find('a.level0').unbind();
			});

			$('.nav-primary').find('.level1.menu-item-has-children').each(function () {
				var mainli = $(this);
				mainli.find('a.level1').unbind();
			});

			$('.nav-primary').find('.level0').each(function () {

				var mainlink = $(this);

				mainlink.unbind();

			});

			$('.nav-primary').find('.level1').each(function () {

				var mainlink = $(this);

				mainlink.unbind();

			});

			$('.nav-primary').find('.level0.menu-item-has-children').each(function () {

				var mainli = $(this);

				//console.log(mainli);

				mainli.find('a.level0').click(function () {

					//console.log('huhu');

					mainli.toggleClass('active');

					return false;
				});

			});

			$('.nav-primary').find('.level1.menu-item-has-children').each(function () {

				var mainli = $(this);

				//console.log(mainli);

				mainli.find('a.level1').click(function () {

					//console.log('hehe');

					mainli.toggleClass('active');

					return false;
				});

			});

		}

		//$('<li id="menu-item-800-term-38989898" class="ubermenu-item ubermenu-item-type-custom ubermenu-item-object-ubermenu-custom ubermenu-dynamic-term ubermenu-item-800-term-3888 ubermenu-item-auto ubermenu-item-normal ubermenu-item-level-3 ubermenu-column ubermenu-column-auto"><a class="ubermenu-target ubermenu-item-layout-default ubermenu-item-layout-text_only" href="http://agency.koeln/fruehmessner/produkte/"><span class="ubermenu-target-title ubermenu-target-text">Alle Produkte</span></a></li>').insertAfter('#menu-item-800-term-37');

		$('.tag-links').find('a').each(function (i, val) {

			$('<i class="fa fa-tag"></i>').prependTo($(this));

		});

		$('#responsiveTabs').responsiveTabs({
			//startCollapsed: 'accordion'
		});

		$('<i class="fa fa-wordpress"></i>&nbsp;&nbsp;').prependTo('.post-edit-link');

		$('input[type="submit"]').each(function () {

			var datSubfukr = $(this);
			var datValue = datSubfukr.val();
			var datParent = datSubfukr.parent();

			$('<button type="submit" name="haha" class="">' + datValue + '</button>').prependTo(datParent);
			datSubfukr.remove();

		});

		$('.textwidget').find('a').each(function () {

			var datPDFLink = $(this);
			var datPDFLinkValue = $(this).attr('href');

			if (datPDFLinkValue.indexOf('.pdf') > -1 || datPDFLinkValue.indexOf('.PDF') > -1) {
				datPDFLink.addClass('button');
				datPDFLink.click(function (event) {
					event.preventDefault();
					window.open(datPDFLinkValue, '', '');
				})
			}

		});

		var datLogout = $('.wppb-logout-url');
		var datLogoutParent = datLogout.parent();

		$('#datLogout').attr('href', datLogout.attr('href'));
		datLogoutParent.remove();

		/*

		$('.panel-row-style').find('.panel-grid-cell').each(function(i,val) {

			var datGridCell = $(this);

			var parentHeight = datGridCell.parent().height();
			//alert(parentHeight);

			datGridCell.css('padding-top', (parentHeight - datGridCell.height()) / 2 );

		});

	*/

		$('.datGroup').click(function () {

			if (!$(this).next('.gruppe').hasClass('hidden-sosa')) {

				$(this).next('.gruppe').addClass('hidden-sosa').removeClass('openBackground');
				$(this).removeClass('openBackground');

				$(this).find('i.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');

			} else {

				$('.gruppe').each(function () {
					$(this).addClass('hidden-sosa');
				});
				$('.datGroup').each(function () {
					$(this).removeClass('openBackground');
					$(this).find('i.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
				});

				$(this).next('.gruppe').removeClass('hidden-sosa').addClass('openBackground');
				$(this).addClass('openBackground');
				$(this).find('i.fa-angle-down').removeClass('fa-angle-down').addClass('fa-angle-up');
			}
		});

		$('.datGroup').each(function (i, val) {
			var oneHead = $(this);
			var image = oneHead.next('.gruppe').find('img:eq(0)').attr('src');
			$('<img src="' + image + '" alt="bluete" />').appendTo(oneHead.find('.bluete_header'));

		});

		$('.datDownload.title').click(function () {

			if ($(this).next('.grouped').css('display') != 'none') {

				$(this).next('.grouped').fadeOut();
				$(this).removeClass('selecta');

				$(this).find('i.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');

			} else {

				$(this).next('.grouped').fadeIn();
				$(this).find('i.fa-angle-down').removeClass('fa-angle-down').addClass('fa-angle-up');
				$(this).addClass('selecta');
			}

		});

		var datStartPos = $('.owl-carousel-start-position').text();
		//alert(datStartPos);
		var owlbluete = $('.owl-carousel.bluete'); // save reference to variable

		owlbluete.owlCarousel({
			items: 1,
			loop: false,
			center: true,
			callbacks: true,
			//animateOut: 'fadeOut',
			margin: 10,

			//URLhashListener:true,
			//startPosition: 'URLHash'
			startPosition: datStartPos
		});

		/*
		$('.next').click(function(event) {
			event.preventDefault();
			window.setTimeout(function(){
				owlbluete.trigger('next.owl.carousel');
			   },200);

			tefoda();
		})
		// Go to the previous item
		$('.previous').click(function(event) {
			event.preventDefault();
			// With optional speed parameter
			// Parameters has to be in square bracket '[]'
			window.setTimeout(function(){
				owlbluete.trigger('prev.owl.carousel');
			   },200);

			tefoda();

		});
		*/

		// documantation

		function tefoda() {

			//alert('tefoda');

			/*
			$('.bluntTopper').css('opacity','0');
			$('.bluntBottomless').css('opacity','0');

			window.setTimeout(function(){
			  $('.bluntTopper').css('opacity','1');
			  $('.bluntBottomless').css('opacity','1');
			},800);
			*/

			$('.bluntTopper').removeClass('fadeInDown').css('opacity', '0');
			$('.bluntBottomless').removeClass('fadeInUp').css('opacity', '0');

			window.setTimeout(function () {
				$('.bluntTopper').css('opacity', '1');
				$('.bluntBottomless').css('opacity', '1');
			}, 800);

		}

		var biggerCar = $('#homehero');

		biggerCar.owlCarousel({
			loop: false,
			items: 1,
			autoplaySpeed: 800,
			dotsSpeed: 800,
			smartSpeed: 800,
			navSpeed: 800,
			/* animateOut: 'fadeOut',
			 animateIn: 'fadeInDown',*/
			dots: true,
			autoplay: true,
			autoplayTimeout: 7000,
			callbacks: true,
			responsive: {
				0: {
					items: 1,
					nav: false,
					autoHeight: false
				},
				650: {
					items: 1,
					nav: false,
					autoHeight: false
				},
				1000: {
					items: 1,
					nav: false,
					autoHeight: false
				}
			}
		});

		$('.allproidshome.next').click(function (event) {
			event.preventDefault();

			window.setTimeout(function () {
				biggerCar.trigger('next.owl.carousel');
			}, 200);

			//tefoda();
		})
		// Go to the previous item
		$('.allproidshome.previous').click(function (event) {
			event.preventDefault();

			window.setTimeout(function () {
				biggerCar.trigger('prev.owl.carousel');
			}, 200);

			//tefoda();

		});

		biggerCar.on('changed.owl.carousel', function (event) {

			evCall();
		})

		function evCall() {

			$('.text').addClass('hide');
			$('.sliderprodcfuk').css('opacity', '0');

			window.setTimeout(function () {
				$('.text').removeClass('hide');
			}, 500);

			window.setTimeout(function () {
				$('.sliderprodcfuk').css('opacity', '1');
			}, 900);

		}

		$('.owl-carousel.small').each(function () {

			var carouproids = $(this);

			carouproids.owlCarousel({
				loop: true,
				margin: 0,
				nav: false,
				responsive: {
					0: {
						items: 1,
						dots: false,
					},
					661: {
						items: 2,
						dots: false,
					},
					900: {
						items: 3,
						dots: false,
					},
					1377: {
						items: 4,
						dots: true,
						loop: false,
					}
				}
			});

			// Now move the carousel to the third item.
			//owl = $("#owl-demo").data('owlCarousel');
			//carouproids.jumpTo(3);

			carouproids.parent().find('.allproids .next').click(function (event) {
				event.preventDefault();
				window.setTimeout(function () {
					carouproids.trigger('next.owl.carousel');
				}, 200);

				//tefoda();
			})
			// Go to the previous item
			carouproids.parent().find('.allproids .previous').click(function (event) {
				event.preventDefault();
				// With optional speed parameter
				// Parameters has to be in square bracket '[]'
				window.setTimeout(function () {
					carouproids.trigger('prev.owl.carousel');
				}, 200);

				//tefoda();

			});

		});

		$('.owl-carousel.timeline').each(function () {

			var timeline = $(this);

			timeline.owlCarousel({
				loop: true,
				margin: 40,
				nav: false,

				responsive: {
					0: {
						items: 1,
						dots: false,
						margin: 10,
						stagePadding: 10,
					},
					661: {
						items: 2,
						dots: false,
						margin: 20,
						stagePadding: 20,
					},
					900: {
						items: 3,
						dots: false,
						margin: 40,
						stagePadding: 40,
					},

				}
			});

			// Now move the carousel to the third item.
			//owl = $("#owl-demo").data('owlCarousel');
			//carouproids.jumpTo(3);

			timeline.parent().find('.allproids .next').click(function (event) {
				event.preventDefault();
				window.setTimeout(function () {
					timeline.trigger('next.owl.carousel');
				}, 200);

				//tefoda();
			})
			// Go to the previous item
			timeline.parent().find('.allproids .previous').click(function (event) {
				event.preventDefault();
				// With optional speed parameter
				// Parameters has to be in square bracket '[]'
				window.setTimeout(function () {
					timeline.trigger('prev.owl.carousel');
				}, 200);

				//tefoda();

			});

		});

		var inhaltsstoffeProdukt = $('.product-image-gallery');

		inhaltsstoffeProdukt.owlCarousel({
			loop: true,
			margin: 0,
			nav: false,
			items: 1

		});

		// Now move the carousel to the third item.
		//owl = $("#owl-demo").data('owlCarousel');
		//carouproids.jumpTo(3);

		$('.allproids .next').click(function (event) {
			event.preventDefault();
			window.setTimeout(function () {
				inhaltsstoffeProdukt.trigger('next.owl.carousel');
			}, 200);

			//tefoda();
		})
		// Go to the previous item
		$('.allproids .previous').click(function (event) {
			event.preventDefault();
			// With optional speed parameter
			// Parameters has to be in square bracket '[]'
			window.setTimeout(function () {
				inhaltsstoffeProdukt.trigger('prev.owl.carousel');
			}, 200);

			//tefoda();

		});

		$('.product-image-gallery.owl-theme .owl-dots .owl-dot span').each(function (i, val) {

			var oneDot = $(this);

			var thisImage = $('.product-image-gallery.owl-theme .owl-item:not(.cloned):eq(' + i + ')').find('img').attr('src');

			oneDot.css('background-image', 'url(' + thisImage + ')');

		});

		$('.fixed-subnavi').find('a').each(function (i, val) {
			var subitem = $(this);

			subitem.click(function () {

				$('.fixed-subnavi a').removeClass('active');

				subitem.addClass('active');

				var datBlock = subitem.data('id');

				// $('.'+datBlock).addClass('highlight');
				// alert(datBlock);

			});
		});

		/*
			$('.dablunt').matchHeight({
				byRow: true,
				property: 'height',
				target: null,
				remove: false
			});
		*/

		/*
			$('.feature-title').matchHeight({
				byRow: true,
				property: 'height',
				target: null,
				remove: false
			});

			$('.feature-p').matchHeight({
				byRow: true,
				property: 'height',
				target: null,
				remove: false
			});
		*/
		$('a.frage').click(function (event) {
			event.preventDefault();

			var datQuest = $(this);

			var datQuestContainer = datQuest.closest('.gruppe.fragebogen');

			datQuestContainer.find('.check i').each(function (i, val) {
				$(this).removeClass('fa-check-square-o').addClass('fa-square-o');
			});

			datQuestContainer.find('a.frage').each(function (i, val) {
				$(this).removeClass('active');
			});

			$('.datGroup').each(function () {
				var ggg = $(this);
				if (ggg.hasClass('openBackground') && ggg.find('i.fa-check').length < 1)
					$('<i class="fa fa-check"></i>').prependTo(ggg);
			});

			datQuest.find('.check i').removeClass('fa-square-o').addClass('fa-check-square-o');
			datQuest.addClass('active');

			$('.fragebutt').removeClass('inactive');

		});

		$('.fragebutt').click(function () {
			var datButt = $(this);

			var answerList = '';

			if (datButt.hasClass('inactive')) {
				alert('Bitte mindestens eine Anwort einer Frage auswählen!');
			} else {

				var contas = 0;

				$('a.frage').each(function (i, val) {
					var datFrage = $(this);
					if (datFrage.hasClass('active')) {

						if (contas == 0)
							answerList += '?fb=' + datFrage.attr('id');
						else
							answerList += 'oooo' + datFrage.attr('id');
						//alert(datFrage.attr('id'));

						contas++;
					}

				});

				window.location = "/bachblueten/auswertung/" + answerList;

				//alert(answerList.join());

			}

		});

		checkSlider();
		positionSliderButts();

		$('.checker-someflowers').prependTo('#datNooke');

	});

	$(window).load(function () {

		var pop = $('.map-popup');
		pop.click(function (e) {
			//e.stopPropagation();
		});

		if ($(window).width() < 1025) {

			$('a.marker').click(function (e) {

				if ($(this).hasClass('marker1')) {

					$('#marker2').removeClass('open');
					$('#marker3').removeClass('open');
					$('#marker4').removeClass('open');

					$('#marker1').addClass('open');

				}

				if ($(this).hasClass('marker2')) {

					$('#marker1').removeClass('open');
					$('#marker3').removeClass('open');
					$('#marker4').removeClass('open');

					$('#marker2').addClass('open');

				}

				if ($(this).hasClass('marker3')) {

					$('#marker2').removeClass('open');
					$('#marker1').removeClass('open');
					$('#marker4').removeClass('open');

					$('#marker3').addClass('open');

				}

				if ($(this).hasClass('marker4')) {

					$('#marker2').removeClass('open');
					$('#marker3').removeClass('open');
					$('#marker1').removeClass('open');

					$('#marker4').addClass('open');

				}

				return false;

			});

			$(document).click(function () {
				pop.removeClass('open');
			});

		} else {

			$('a.marker').mouseenter(function (e) {

				if ($(this).hasClass('marker1')) {

					$('#marker2').removeClass('open');
					$('#marker3').removeClass('open');
					$('#marker4').removeClass('open');

					$('#marker1').addClass('open');

				}

				if ($(this).hasClass('marker2')) {

					$('#marker1').removeClass('open');
					$('#marker3').removeClass('open');
					$('#marker4').removeClass('open');

					$('#marker2').addClass('open');

				}

				if ($(this).hasClass('marker3')) {

					$('#marker2').removeClass('open');
					$('#marker1').removeClass('open');
					$('#marker4').removeClass('open');

					$('#marker3').addClass('open');

				}

				if ($(this).hasClass('marker4')) {

					$('#marker2').removeClass('open');
					$('#marker3').removeClass('open');
					$('#marker1').removeClass('open');

					$('#marker4').addClass('open');

				}

				return false;
			});

			$('a.marker').mouseleave(function (e) {
				$('#marker2').removeClass('open');
				$('#marker3').removeClass('open');
				$('#marker1').removeClass('open');

				$('#marker4').removeClass('open');
			});

		}

		pop.each(function () {
			var w = $(window).outerWidth(),
				edge = Math.round(($(this).offset().left) + ($(this).outerWidth()));
			if (w < edge) {
				$(this).addClass('edge');
			}
		});

		/*	$('.fullrow').each(function(i,val) {

				var lorwocher = $(this);

				window.setTimeout(function() {

					if (i == 3) {
						lorwocher.addClass('animated fadeInUp');
					} else {
						lorwocher.addClass('animated fadeIn');
					}

				}, (i * 100));

			});*/

		$('.hidden').find('select').appendTo('.ichbin');

		$('.isotopfilter').each(function (i, val) {

			var datLink = $(this).find('a');

			datLink.click(function (event) {
				event.preventDefault();

			});

		});

		$('.tag-dropdown-isotope').change(function () {

			window.location = 'http://agency.koeln/bachblueten/bachblueten-produkte/?tag=' + $(this).val();

		});

		$('.category-dropdown-isotope').change(function () {

			window.location = $(this).val()

		});

		$('#loginform').submit(function () {

			var daFomr = $(this);

			if (daFomr.find('#user_login').val() == '' || daFomr.find('#user_pass').val() == '') {
				return false;
			} else {
				return true;
			}

		});

	})

	var rtime;
	var timeout = false;
	var delta = 200;
	$(window).resize(function () {
		rtime = new Date();
		if (timeout === false) {
			timeout = true;
			setTimeout(checkSlider, delta);
		}
	});

	$(window).resize();

	function padder() {
		//alert($('.siteorigin-panels-stretch.panel-row-style').css('margin-left'));
		//$('.siteorigin-panels-stretch.panel-row-style').css('margin-right',$('.siteorigin-panels-stretch.panel-row-style').css('margin-left') );
		//$('.siteorigin-panels-stretch.panel-row-style').css('padding-right',$('.siteorigin-panels-stretch.panel-row-style').css('padding-left') );
	}

	function checkSlider() {

		$('.reasons').each(function () {

			/*  var row = $(this);
			  var headerText = row.find('.header-text');
			  var image = row.find('img');

			  headerText.css('height', row.height());
			  headerText.css('width', row.width() - image.width());
			 // headerText.css('background-color', 'red');

		*/

		});

		if ($(window).width() > 650) {

			$('.block-bewertungen').css('height', $(window).height() - 100);

		} else {

			$('.block-bewertungen').css('height', $(window).height() - 60);

		}

		var winWidth = $(window).width();

		if (winWidth >= 1000) {

			$('.nav-primary').find('.level0.menu-item-has-children').each(function () {
				var mainli = $(this);
				mainli.find('a.level0').unbind();
			});

			$('.nav-primary').find('.level1.menu-item-has-children').each(function () {
				var mainli = $(this);
				mainli.find('a.level1').unbind();
			});

			$('.nav-primary').find('.level0').each(function () {

				var mainlink = $(this);

				mainlink.mouseenter(function () {

					mainlink.addClass('menu-active');
					mainlink.find('a.level0').addClass('active');

				}).mouseleave(function () {

					mainlink.removeClass('menu-active');
					mainlink.find('a.level0').removeClass('active');

				});
			});

		} else {

			$('.nav-primary').find('.level0').each(function () {

				var mainlink = $(this);

				mainlink.unbind();

			});

			$('.nav-primary').find('.level1').each(function () {

				var mainlink = $(this);

				mainlink.unbind();

			});

			$('.nav-primary').find('.level0.menu-item-has-children').each(function () {

				var mainli = $(this);

				//console.log(mainli);

				mainli.find('a.level0').click(function () {

					//console.log('huhu');

					mainli.toggleClass('active');

					return false;
				});

			});

			$('.nav-primary').find('.level1.menu-item-has-children').each(function () {

				var mainli = $(this);

				console.log(mainli);

				mainli.find('a.level1').click(function () {

					mainli.toggleClass('active');

					return false;
				});

			});

			/////////

			$('.nav-primary').find('.level0:first-of-type').each(function () {

				var mainLi = $(this);

				mainLi.find('a.level0').unbind();
				mainLi.find('a.level0').click(function () {

					return true;

				});

			});

			$('.nav-primary').find('.level0:nth-of-type(2)').each(function () {

				var mainLi = $(this);
				var mainUl = mainLi.find('ul.level0');
				var mainLink = mainLi.find('a.level0');

				if (mainLi.find('.prepended').length < 1) {
					$('<li class="menu-item menu-item-type-custom menu-item-object-custom nav-1 level1 prepended"><a href="' + mainLink.attr('href') + '" class="level1">' + mainLink.text() + '</a></li>').prependTo(mainUl);
				}

			});

			$('.nav-primary').find('.level0:nth-of-type(4)').each(function () {

				var tmainLi = $(this);

				tmainLi.find('li.level1').each(function () {

					var mainLi = $(this);

					var mainUl = mainLi.find('ul.level1');
					var mainLink = mainLi.find('a.level1');

					if (mainLi.find('.prepended').length < 1) {

						$('<li class="menu-item menu-item-type-custom menu-item-object-custom nav-2 level2 prepended"><a href="' + mainLink.attr('href') + '" class="level2">Übersicht</a></li>').prependTo(mainUl);
					}

				});

			});

		}

		checkHeader();
		positionSliderButts();

		if (new Date() - rtime < delta) {
			setTimeout(checkSlider, delta);
		} else {
			timeout = false;

			/*
			var winda = $(window).width();
			if ($( ".panel-grid:eq(0)").length > 0) {
				if (winda > 650) {
					if (winda < 961) {
						var p = $( ".panel-grid:eq(0)");
						var position = p.offset();
						$('.start-item .container').css('left',position.left );
					} else if (winda < 1024) {
						var p = $( ".panel-grid:eq(0)");
						var position = p.offset();
						$('.start-item .container').css('left',position.left );
					} else {
						var p = $( ".panel-grid:eq(0)");
						var position = p.offset();
						$('.start-item .container').css('left',position.left);
					}
				}
			}
	*/

		}

		/*
				if ($('.bg_image_height').length > 0) {

					$('.bg_image_height').each(function(i,val) {

						var oneRow = $(this);

						if ($('.daerrbomb').length < 1) {

							$('<div class="container padless rowkiller"></div>').prependTo(oneRow);

							var bgImage = oneRow.css('background-image').replace('url(','').replace(')','');
							var lasLocas = $('<img src="'+bgImage+'" class="daerrbomb" alt="" />');
							lasLocas.prependTo(oneRow);

							oneRow.find('.panel-grid-cell').each(function(i,val) {
								var oneCol = $(this);
								oneCol.appendTo(oneRow.find('.rowkiller'));
								//oneCol.css('margin-top', '-'+oneRow.height()+'px');

							});

							oneRow.css('background-image','');

						} else {
							var lasLocas = $('.daerrbomb');

						}

						if (winda > 780) {

							window.setTimeout(function(){

								lasLocas.css('width', $(window).width());

								oneRow.find('.rowkiller').css('position', 'absolute');
								oneRow.css('line-height', '0');

								var cosas = (lasLocas.height() / 2 ) + (oneRow.find('.rowkiller').height() / 2);

								oneRow.find('.rowkiller').css('margin-top', '-'+ cosas +'px' );

								lasLocas.css('margin-right',$('.siteorigin-panels-stretch.panel-row-style').css('margin-right') );
								lasLocas.css('margin-left',$('.siteorigin-panels-stretch.panel-row-style').css('margin-left') );

								lasLocas.closest('.panel-row-style').css('padding-top', '0');
								lasLocas.closest('.panel-row-style').css('padding-bottom', '0');

							},8);

						} else {

							window.setTimeout(function(){

								lasLocas.css('width', $(window).width());

								oneRow.find('.rowkiller').css('position', 'relative');

								lasLocas.css('margin-right',$('.siteorigin-panels-stretch.panel-row-style').css('margin-right') );
								lasLocas.css('margin-left',$('.siteorigin-panels-stretch.panel-row-style').css('margin-left') );

								lasLocas.closest('.panel-row-style').css('padding-top', '0');
								lasLocas.closest('.panel-row-style').css('padding-bottom', '40px');

							},8);

						}

					});

				}

			}
		*/

		/*var img = new Image();
						img.onload = function() {
						  console.log(this.width + 'x' + this.height);
						};
					img.src = /whatever you need/

					alert(lasLocas.css('height'));*/

	}
})(jQuery);